<template>
  <v-app>
    <v-card class="grlCardInfo">
      <v-breadcrumbs :items="obtRuta" class="grlClase">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            @click="insertarRuta(item.ruta)"
            :disabled="item.disabled"
          >
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-card>
    <v-card>
      <v-img :src="imgTitle" class="grlCardImg">
        <div class="grlCardInfo">
          <h1 class="my-auto hidden-sm-and-down">Organigrama General</h1>
        </div>
      </v-img>
    </v-card>
    <!--CONTENEDOR DE LOS DOCENTES PERTENECIENTES A LA UJED-->
    <div class="estiloDirUno">
      <div style="padding: 2%; background-color: #fff;">
      <v-tabs v-model="tab">
      <v-tabs-slider color="#b11830"></v-tabs-slider>
      <v-tab>
        Personal
      </v-tab>
      <v-tab>
        Organigrama
      </v-tab>
      <v-tab-item class="pt-5">
        <div class="estiloDirInfo">
        <div style="padding-right: 1%">
        <v-list three-line>
          <template v-for="(item, index) in items">
            <v-subheader
              v-if="item.header"
              :key="item.header"
              v-text="item.header"
            />
            <v-divider
              v-else-if="item.divider"
              :key="index"
              :inset="item.inset"
            />
            <v-list-item v-else :key="item.title">
              <v-list-item-avatar>
                <v-img :alt="item.title" :src="item.avatar"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-html="item.title" />
                <v-list-item-subtitle v-html="item.subtitle" />
                <v-list-item-subtitle v-html="item.email" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </div>
      <div>
        <v-list three-line>
          <template v-for="(item, index) in items_faz">
            <v-subheader
              v-if="item.header"
              :key="item.header"
              v-text="item.header"
            />
            <v-divider
              v-else-if="item.divider"
              :key="index"
              :inset="item.inset"
            ></v-divider>
            <v-list-item v-else :key="item.title">
              <v-list-item-avatar>
                <v-img :alt="item.title" :src="item.avatar" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-html="item.title" />
                <v-list-item-subtitle v-html="item.subtitle" />
                <v-list-item-subtitle v-html="item.email" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </div>
      </div>
      </v-tab-item>
      <v-tab-item class="pt-5">
        <v-img class="orgImg" :src="img"></v-img>
      </v-tab-item>
    </v-tabs>
    </div>      
    </div>
    <!--CONTENEDOR DE LOS DOCENTES PERTENECIENTES A LA FACULTAD-->
  </v-app>
</template>
<script>
export default {
  data: () => ({
    img: require("../../assets/img/organigrama_img.png"),
    imgTitle: require("../../assets/img/banner-organigrama.jpg"),
    obtRuta: [
      {
        text: "Inicio",
        disabled: false,
        ruta: "/",
      },
      {
        text: "Directorio",
        disabled: true,
        ruta: "breadcrumbs_link_1",
      },
    ],
    items: [
      { header: "Universidad Juárez del Estado de Durango" },
      {
        avatar: require("@/assets/images/Planta Academica/usuario.png"),
        title: "M.A. Rubén Solís Ríos",
        subtitle: `Rector`,
      },
      { divider: true, inset: true },
      {
        avatar: require("@/assets/images/Planta Academica/usuario.png"),
        title: "M.C. Julio Gerardo Lozoya Vélez",
        subtitle: `Secretario General`,
        email: "secretariogeneral@ujed.mx",
      },
      { divider: true, inset: true },
      {
        avatar: require("@/assets/images/Planta Academica/usuario.png"),
        title: "M.A.F. María Lizett Valles Freyre",
        subtitle: `Subsecretario General de Administración`,
        email: "",
      },
      { divider: true, inset: true },
      {
        avatar: require("@/assets/images/Planta Academica/usuario.png"),
        title: "Dr. José Othón Huerta Herrera",
        subtitle: "Subsecretario General Académico",
        email: "ohuerta@ujed.mx",
      },
      { divider: true, inset: true },
      {
        avatar: require("@/assets/images/Planta Academica/usuario.png"),
        title: "M. D. Alma Isela Cardoza Pacheco",
        subtitle: "Directora de Servicios Escolares",
        email: "",
      },
      { divider: true, inset: true },
      {
        avatar: require("@/assets/images/Planta Academica/usuario.png"),
        title: "Dr. Jaime Fernández Escárzaga",
        subtitle: "Director Institucional de Posgrado e Investigación",
        email: "posgrado_ujed@hotmail.com",
      },
    ],
    //Objeto que contiene la informacion de los docentes de la facultad
    items_faz: [
      { header: "Facultad de Agricultura y Zootecnia" },
      {
        avatar: require("@/assets/images/Planta Academica/vazquez.jpg"),
        title: "Dr. Cirilo Vázquez Vázquez",
        subtitle: `Director`,
        email: "cirvaz60@hotmail.com",
      },
      { divider: true, inset: true },
      {
        avatar: require("@/assets/images/Planta Academica/usuario.png"),
        title: "Dra. Maribel Navarro Morones",
        subtitle: `Secretaria Académica`,
        email: "mabel_navarro81@hotmail.com",
      },
      { divider: true, inset: true },
      {
        avatar: require("@/assets/images/Planta Academica/z_valenzuela.jpg"),
        title: "Dra. Elizabeth Zúñiga Valenzuela",
        subtitle: `Secretaria Administrativa`,
        email: "elizabeth.zuniga.val@yahoo.com.mx",
      },
      { divider: true, inset: true },
      {
        avatar: require("@/assets/images/Planta Academica/gallegos.jpg"),
        title: "Dr. Miguel Angel Gallegos Robles",
        subtitle: "Jefe de la División de Estudios de Posgrado",
        email: "garoma64@hotmail.com",
      },
      { divider: true, inset: true },
      {
        avatar: require("@/assets/images/Planta Academica/garcia.jpg"),
        title: "Dr. José Luis García Hernández",
        subtitle: "Coordinador de Investigación",
        email: "luis_garher@hotmail.com",
      },
      {},
    ],
  }),
  methods: {
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
  },
};
</script>
